
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useRef, useState } from "react";

import Config from "@skin_config";

import VirtualGamesSportList from "../../components/virtualGamesSportList";
import { casinoGamesPageOpened } from "../../../actions/terminal";
import { useDispatch } from "react-redux";
import { browserHistory } from 'react-router';

const VirtualGames = () => {
    const dispatch = useDispatch()
    const [provider, setProvider] = useState()

    const scrollVirtualGames = useRef()

    const handleSelectProvider = (provider) => {
        if (provider.type === 'iframe') {
            browserHistory.push(`/thirdPartyGame/${provider.id}`)
            dispatch(casinoGamesPageOpened())
        } else {
            setProvider(provider.name)
        }
    }

    useEffect(() => {
        if (!provider) {
            const providersList = Object.values(Config.virtualGames.providers)

            const defaultProvider = providersList.length === 1
                ? providersList[0]
                : providersList.find(item => item.default && item.type !== 'iframe')
                || providersList.find(item => item.type !== 'iframe')

            if (defaultProvider) handleSelectProvider(defaultProvider)
        }
    }, [provider])

    const scroll = (scrollSize) => {
        let delta

        return () => {
            let iterator = (scrollSize > 0 ? 0.1 : -0.1);
            delta = delta || iterator;
            delta += iterator;
            scrollVirtualGames.current.scrollTop += (scrollSize + delta);
        };
    }

    return (<div className="virtual-games-wrapper" ref={scrollVirtualGames}>
        <VirtualGamesSportList
            key={provider}
            handleSelectProvider={handleSelectProvider}
            selectedProvider={provider}
        />
        <div className="scroll-b-view-w virtual">
            <div className="single-s-b top-v" onClick={scroll(-200)} />
            <div className="single-s-b bot-v" onClick={scroll(200)} />
        </div>
    </div>);
}

export default VirtualGames